// extracted by mini-css-extract-plugin
export default {"removeButton":"removeButton--sxCF5"};